import * as React from 'react';
import { AnimatePresence } from 'framer-motion';
import type { ToastProps } from '../Toast/Toast';
import Toast from '../Toast/Toast';

import './toasts-list.scss';

type Props = {
    toasts: ToastProps[];
    onDismiss: { (toast: ToastProps): void };
};

const ToastsList = (props: Props): JSX.Element => (
    <div className="toasts-list">
        <AnimatePresence initial={false}>
            {props.toasts.map((toast) => (
                <Toast
                    key={toast.id}
                    animate
                    {...toast}
                    onDismiss={() => {
                        props.onDismiss(toast);
                        toast.onDismiss?.();
                    }}
                    showAnimation={{ marginBottom: 8 }}
                    hideAnimation={{ marginBottom: 0 }}
                />
            ))}
        </AnimatePresence>
    </div>
);

export default ToastsList;
